import { render } from "./Object.vue?vue&type=template&id=86f19066&scoped=true&ts=true"
import script from "./Object.vue?vue&type=script&lang=ts"
export * from "./Object.vue?vue&type=script&lang=ts"

import "./Object.vue?vue&type=style&index=0&id=86f19066&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f19066"]])

export default __exports__